import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import Loading from "../../../../components/Loading/Loading";
import localeText from "../../../../locale";
import WalletService from "../../../../service/WalletService";
import handleLocale from "../../../../utilities/LocaleSwitch";
import ValidateUserInfo from "../../../../utilities/ValidateUserInfo";
import { formatPrice } from "../../../../utilities/formatPrice";
import { locale } from "../../../../utilities/locale/locale";
import ListUserWithdrawRequests from "../../components/ListUserWithdrawRequests/ListUserWithdrawRequests";
import CreateFinancialPasswordModal from "../../../../components/CreateFinancialPasswordModal/CreateFinancialPasswordModal";
import { useToggle } from "../../../../hooks/useToggle";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import useFinantialPassword from "../../../../hooks/useFinantialPassword";
import { SelectButton } from "primereact/selectbutton";

export const typeTransfer = {
  PAYPAL: "PAYPAL",
  BANK: "BANK",
};

const WithdrawIntent = (props) => {
  const options = ["PayPal", localeText("bank")];

  const [confirmWithdraw, setConfirmWithdraw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState(0);
  const [toEmail, setToEmail] = useState("");
  const [withdrawInfo, setWithdrawInfo] = useState({});
  const [financialPassword, setFinancialPassword] = useState("");
  const [loadingWithdrawRequests, setLoadingWithdrawRequests] = useState(false);
  const [retryFetch, setRetryFetch] = useState(true);

  const [typeWithdraw, setTypeWithdraw] = useState();
  const [bankName, setBankName] = useState("");
  const [iban, setIban] = useState(""); // número da conta bancaria
  const [accountOwner, setAccountOwner] = useState(""); // titular da conta bancaria

  const { currency, walletInfo } = props;

  let currencyCode = "USD";
  let localeISO = "en-US";

  const toast = useRef(null);
  const emailRef = useRef(null);
  const financialPasswordRef = useRef(null);

  currencyCode = currency !== "$" ? currency : "USD";

  localeISO = handleLocale(locale);

  const walletService = new WalletService();
  const validateUserInfo = new ValidateUserInfo(toast, emailRef, null, setToEmail);

  const setAmountAction = (value) => {
    setAmount(value);

    if (value >= walletInfo?.balance)
      toast.current.show({
        severity: "warn",
        summary: localeText("attention"),
        detail: localeText("maxBalanceReached"),
        life: 6000,
      });
  };

  async function createWithdrawIntent(token, username, amount, email) {
    try {
      setLoading(true);

      if (amount === 0) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("amountCantBeZero"),
          life: 6000,
        });
        setLoading(false);
        return false;
      }
      console.log(iban.length, bankName.length, accountOwner.length);
      if (typeWithdraw === "PayPal" && !(await validateUserInfo.validateEmailRegex(email))) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("invalidemail"),
          life: 6000,
        });
        setLoading(false);
        return false;
      } else if (
        typeWithdraw === localeText("bank") &&
        (iban.length === 0 || bankName.length === 0 || accountOwner.length === 0)
      ) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("allFieldsRequired"),
          life: 6000,
        });
        setLoading(false);
        return;
      }

      let res = {};

      if (typeWithdraw === "PayPal") {
        res = await walletService.postWithdrawIntent(
          token,
          username,
          amount,
          email,
          typeTransfer.PAYPAL
        );
      } else {
        res = await walletService.postWithdrawIntent(
          token,
          username,
          amount,
          null,
          typeTransfer.BANK,
          bankName,
          iban,
          accountOwner
        );
      }

      if (res.messageCode !== 200001) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        if (res.messageCode === 500000) console.log(res);
        setLoading(false);
      } else {
        setWithdrawInfo(res.result);
        setConfirmWithdraw(true);
        setLoading(false);
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      setLoading(false);
      console.log(e);
    }
  }

  async function confirmWithdrawRequest(token, username, amount, email, financialPassword) {
    try {
      if (financialPassword.length === 0) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("financialPasswordCantBeEmpty"),
          life: 6000,
        });
        financialPasswordRef.current.style.border = "1px solid red";
        return false;
      }

      setLoadingWithdrawRequests(true);

      let res = {};

      if (typeWithdraw === "PayPal") {
        res = await walletService.postWithdrawRequest(
          token,
          username,
          amount,
          email,
          financialPassword
        );
      } else {
        res = await walletService.postWithdrawRequest(
          token,
          username,
          amount,
          null,
          financialPassword,
          typeTransfer.BANK,
          bankName,
          iban,
          accountOwner
        );
      }

      if (res.messageCode === 500166) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("financialPasswordIsWrong"),
          life: 6000,
        });
        setLoadingWithdrawRequests(false);
      } else if (res.messageCode !== 200001) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoadingWithdrawRequests(false);
        if (res.messageCode === 500000) console.log(res);
      } else {
        toast.current.show({
          severity: "success",
          summary: localeText("success"),
          detail: localeText("amountWithdrawnSuccessfully"),
          life: 6000,
        });
        setLoadingWithdrawRequests(false);
        setConfirmWithdraw(false);
        setRetryFetch(true);
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      setLoadingWithdrawRequests(false);
      console.log(e);
    }
  }

  const { showErrorToast: newShowErrorToast, showSuccessToast } = useToastContext();
  const {
    setAsFalse: closeFinancialPasswordModal,
    setAsTrue: openFinancialPasswordModal,
    value: isVisibleModal,
  } = useToggle();
  const {
    isLoading,
    isLoadingCreateFinancialPassword,
    hasFinantialPassword,
    createFinantialPassword,
    checkFinantialPassword,
  } = useFinantialPassword({
    onError: ({ code }) => newShowErrorToast({ code }),
    onSuccess: () => showSuccessToast({ detail: "passwordCreatedSuccessfully" }),
  });

  const canCreateFinancialPassword =
    /manager/i.test(props?.userTypeInfo) ||
    /partner/i.test(props?.userTypeInfo) ||
    /promoter/i.test(props?.userTypeInfo) ||
    /seller/i.test(props?.userTypeInfo);

  return (
    <div className="card border-1 border-300">
      <Toast ref={toast} position="top-left" />

      <CreateFinancialPasswordModal
        isVisible={isVisibleModal}
        setModalNotVisible={closeFinancialPasswordModal}
        setModalVisible={openFinancialPasswordModal}
        createFinantialPassword={createFinantialPassword}
        canCreateFinancialPassword={canCreateFinancialPassword}
        isLoadingCreateFinancialPassword={isLoadingCreateFinancialPassword}
        isFirstPassword={!hasFinantialPassword}
      />

      <Dialog
        header={
          <>
            <span className="font-bold m-0 p-0 text-2xl">
              {localeText("attention").toUpperCase()}:
            </span>{" "}
            {localeText("confirmYourAction")}
          </>
        }
        visible={confirmWithdraw}
        className="w-30rem mx-2"
        onHide={() => {
          if (!loadingWithdrawRequests) setConfirmWithdraw(false);
        }}
        draggable={false}
      >
        <>
          {loading ? (
            <div>
              <i className="pi pi-spin pi-spinner text-6xl text-400 my-6"></i>
            </div>
          ) : (
            <>
              <div className="my-4">
                {withdrawInfo?.amountRequested && typeWithdraw === "PayPal" && (
                  <ul className="list-none mt-0 mb-4 p-0">
                    <li>
                      {localeText("paypalFee")} {withdrawInfo.fee || 3.4}% + 0,35€{" "}
                      {localeText("onTop")}.
                    </li>
                  </ul>
                )}
                <p>{localeText("askFinancialPassword")}</p>
                <InputText
                  ref={financialPasswordRef}
                  name="financialPassword"
                  type="text"
                  value={financialPassword}
                  onChange={(e) => setFinancialPassword(e.target.value)}
                  onFocus={() => (financialPasswordRef.current.style.border = "1px solid #ced4da")}
                />
              </div>
              <p className="mt-2">{localeText("doYouAgree")}</p>
              <div className="flex gap-2 justify-content-end">
                <Button
                  onClick={() => setConfirmWithdraw(false)}
                  severity="danger"
                  disabled={loadingWithdrawRequests}
                >
                  {localeText("no")}
                </Button>
                <Button
                  onClick={() =>
                    confirmWithdrawRequest(
                      localStorage.getItem("__extraconomy_token"),
                      localStorage.getItem("__extraconomy_username"),
                      amount,
                      toEmail,
                      financialPassword
                    )
                  }
                  disabled={loadingWithdrawRequests}
                  className={`${loadingWithdrawRequests ? "opacity-80" : ""}`}
                >
                  <div className="flex justify-content-center align-items-center gap-2">
                    {loadingWithdrawRequests && <Loading classNameIcon={"text-sm"} disableMargin />}
                    <p>{localeText("yes")}</p>
                  </div>
                </Button>
              </div>
            </>
          )}
        </>
      </Dialog>

      {walletInfo && (
        <>
          <h3 className="my-4">{localeText("withdraw")}</h3>
          <hr />

          <ul className="list-none p-0 mt-6">
            <li className="font-bold">
              <label htmlFor="extracoin-amount">{localeText("amount")}:</label>
            </li>
            <li>
              <InputNumber
                name="extracoin-amount"
                value={amount}
                onValueChange={(e) => setAmountAction(e.value)}
                min={0}
                max={walletInfo?.balance}
                showButtons
                buttonLayout="horizontal"
                decrementButtonClassName="p-button-danger"
                incrementButtonClassName="p-button-success"
                incrementButtonIcon="pi pi-plus"
                decrementButtonIcon="pi pi-minus"
                locale={localeISO}
                step={0.1}
                currency={currencyCode}
                mode="currency"
              />
            </li>

            <li className="font-bold mt-4">{localeText("withdrawWith")}:</li>
            <li className="mt-2">
              <SelectButton
                value={typeWithdraw}
                onChange={(e) => setTypeWithdraw(e.value)}
                options={options}
              />
            </li>
            {typeWithdraw === localeText("bank") && (
              <>
                <li className="font-bold mt-4">
                  <label htmlFor="bankName">{localeText("bankName")}:</label>
                </li>
                <li className="mt-2">
                  <InputText
                    name="bankName"
                    type="text"
                    value={bankName}
                    onChange={(e) => setBankName(e.target.value)}
                  />
                </li>

                <li className="font-bold mt-4">
                  <label htmlFor="iban">{localeText("bankAccountNumber")}:</label>
                </li>
                <li className="mt-2">
                  <InputText
                    name="iban"
                    value={iban}
                    onChange={(e) => {
                      setIban(e.target.value);
                    }}
                  />
                </li>

                <li className="font-bold mt-4">
                  <label htmlFor="accountOwner">{localeText("accountOwner")}:</label>
                </li>
                <li className="mt-2">
                  <InputText
                    name="accountOwner"
                    type="text"
                    value={accountOwner}
                    onChange={(e) => setAccountOwner(e.target.value)}
                  />
                </li>
              </>
            )}

            {typeWithdraw === "PayPal" && (
              <>
                <li className="font-bold mt-4">
                  <label htmlFor="username">{localeText("paypalEmail")}:</label>
                </li>
                <li className="mt-2">
                  <InputText
                    ref={emailRef}
                    name="email"
                    type="text"
                    value={toEmail}
                    onChange={(e) => setToEmail(e.target.value)}
                    onFocus={() => (emailRef.current.style.border = "1px solid #ced4da")}
                  />
                </li>
              </>
            )}

            <li className="flex justify-content-start align-items-center gap-2 flex-wrap">
              <Button
                className="my-4 text-sm"
                label={localeText("requestWithdraw")}
                loading={loading}
                onClick={() =>
                  createWithdrawIntent(
                    localStorage.getItem("__extraconomy_token"),
                    localStorage.getItem("__extraconomy_username"),
                    amount,
                    toEmail
                  )
                }
              />

              {canCreateFinancialPassword && (
                <Button
                  className="text-sm"
                  label={localeText("createNewFinancialPassword")}
                  onClick={() => {
                    checkFinantialPassword().finally(() => {
                      openFinancialPasswordModal();
                    });
                  }}
                  loading={isLoading}
                />
              )}
            </li>

            <li>
              <ListUserWithdrawRequests retryFetch={retryFetch} setRetryFetch={setRetryFetch} />
            </li>
          </ul>
        </>
      )}
    </div>
  );
};

export default WithdrawIntent;
